import { render, staticRenderFns } from "./Destacados.vue?vue&type=template&id=409aa4a2&"
import script from "./Destacados.vue?vue&type=script&lang=js&"
export * from "./Destacados.vue?vue&type=script&lang=js&"
import style0 from "./Destacados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Destacados.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
installComponents(component, {
  VImg,
})
